import {
  Button,
  Checkbox,
  Col,
  Flex,
  Form,
  Image,
  Input,
  Row,
  Typography,
} from "antd";
import styled from "styled-components";
import createAccountBg from "../../../assets/create-account-bg.png";

const { Title, Text, Link } = Typography;
const { Password } = Input;
const { Item } = Form;

export const PageRow = styled(Row)`
  && {
    width: 100%;
    min-height: 100vh;
    margin: 0;
    background: linear-gradient(134deg, #ffffff 1%, #ffffff 100%);
    font-family: "Roboto", sans-serif;
    flex-wrap: nowrap;
  }

  @media (min-width: 992px) {
    && {
      position: fixed;
      inset: 0;
      height: 100vh;
      overflow: hidden;
    }
  }
`;

export const LeftCol = styled(Col)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    padding: 38px 0 38px 34px;
    box-sizing: border-box;
    overflow: hidden;
  }

  @media (max-width: 991px) {
    && {
      display: none;
    }
  }
`;

export const ImageCard = styled(Flex)`
  &&,
  &&:empty {
    display: block;
    width: 100%;
    height: 100%;
    background-image: url(${createAccountBg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #d9d9d9;
    border-radius: 12px;
  }
`;

export const RightCol = styled(Col)`
  && {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    min-height: 100vh;
    padding: 32px 20px;
    box-sizing: border-box;
  }

  @media (min-width: 992px) {
    && {
      height: 100vh;
      min-height: 0;
      padding: 64px 16px 16px;
      overflow: hidden;
    }
  }
`;

export const FormCard = styled(Flex)`
  width: 100%;
  max-width: 414px;

  @media (min-width: 992px) {
    max-height: 100vh;
  }
`;

export const BackButton = styled(Button)`
  && {
    width: 24px;
    height: 24px;
    min-width: 0;
    padding: 0;
    border: none;
    background: transparent;
    color: #28323e;
    box-shadow: none;
    outline: none;
    transition: none;
    margin-bottom: 8px;
    flex-shrink: 0;

    &:hover,
    &:focus,
    &:focus-visible,
    &:active {
      background: transparent !important;
      color: #28323e !important;
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }

    &::after {
      display: none !important;
    }

    .anticon {
      font-size: 16px;
    }
  }
`;

export const LogoImage = styled(Image)`
  margin-bottom: 28px;

  @media (max-width: 575px) {
    margin-bottom: 20px;
  }
`;

export const StyledTitle = styled(Title)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 28px !important;
    font-weight: 700 !important;
    line-height: 36px !important;
    color: #28323e !important;
    text-align: left;
    margin: 0 0 10px !important;
    width: 100%;
  }

  @media (max-width: 575px) {
    && {
      font-size: 24px !important;
      line-height: 32px !important;
    }
  }
`;

export const SubtitleRow = styled(Flex)`
  width: 100%;
  margin-bottom: 14px;
  align-items: center;
`;

export const SubtitleText = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #28323e;
  }
`;

export const SubtitleLink = styled(Link)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: #28323e;
    text-decoration: underline;

    &:hover {
      color: #28323e;
      text-decoration: underline;
    }
  }
`;

export const StyledForm = styled(Form)`
  width: 100%;

  .ant-form-item-label {
    padding-bottom: 4px;
  }

  .ant-form-item-label > label {
    font-family: "Roboto", sans-serif;
    font-size: 11px;
    font-weight: 600;
    line-height: 15px;
    color: #28323e;
    height: auto;
  }

  .ant-form-item {
    margin-bottom: 8px;
  }
`;

export const StyledInput = styled(Input)`
  && {
    height: 32px;
    border: 1px solid #d9d9d9;
    border-radius: 22px;
    padding: 0 16px;
    font-family: "Roboto", sans-serif;
    font-size: 11px;
    font-weight: 400;
    line-height: 15px;
    background: #ffffff;
    color: #28323e;

    &::placeholder {
      color: rgba(40, 50, 62, 0.6);
    }

    &:hover,
    &:focus {
      border-color: #4f78a1;
      box-shadow: none;
    }
  }
`;

export const StyledPasswordInput = styled(Password)`
  && {
    height: 32px;
    border: 1px solid #d9d9d9;
    border-radius: 22px;
    background: #ffffff;
    padding: 0 16px;

    &:hover,
    &:focus-within {
      border-color: #4f78a1;
      box-shadow: none;
    }

    .ant-input {
      border: none;
      background: transparent;
      padding: 0;
      font-family: "Roboto", sans-serif;
      font-size: 11px;
      font-weight: 400;
      line-height: 15px;
      color: #28323e;

      &::placeholder {
        color: rgba(40, 50, 62, 0.6);
      }

      &:focus {
        box-shadow: none;
      }
    }

    .ant-input-suffix {
      color: #28323e;
    }
  }
`;

export const TermsItem = styled(Item)`
  && {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 0;
  }

  .ant-form-item-control-input {
    min-height: auto;
  }
`;

export const TermsText = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 11px;
    font-weight: 400;
    line-height: 15px;
    color: #28323e;
  }
`;

export const TermsLink = styled(Link)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 11px;
    font-weight: 700;
    line-height: 15px;
    color: #28323e;
    text-decoration: underline;

    &:hover {
      color: #28323e;
      text-decoration: underline;
    }
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  && {
    align-items: center;
    gap: 4px;

    .ant-checkbox-inner {
      width: 14px;
      height: 14px;
      border-radius: 3px;
      border: 2px solid #4f78a1;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #4f78a1;
      border-color: #4f78a1;
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: #ffffff;
      border-width: 2px;
    }

    & > span:not(.ant-checkbox) {
      display: inline-flex;
      align-items: baseline;
      gap: 4px;
      padding-inline-start: 8px;
    }
  }
`;

export const SubmitFormItem = styled(Item)`
  && {
    margin-bottom: 0;
    margin-top: 14px;
  }
`;

export const PrimaryButton = styled(Button)`
  && {
    width: 100%;
    height: 40px;
    border-radius: 22px;
    background: #28323e;
    border: none;
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    color: #ffffff;

    &:hover {
      background: #1c2530 !important;
      color: #ffffff !important;
    }
  }
`;

export const OrDivider = styled(Text)`
  && {
    display: flex;
    align-items: center;
    width: 100%;
    font-family: "Roboto", sans-serif;
    font-size: 11px;
    font-weight: 400;
    line-height: 15px;
    color: #28323e;
    margin: 12px 0;
    text-align: center;
    justify-content: center;

    &::before,
    &::after {
      content: "";
      flex: 1;
      border-top: 1px solid rgba(40, 50, 62, 0.2);
    }

    &::before {
      margin-right: 13px;
    }

    &::after {
      margin-left: 13px;
    }
  }
`;

export const GoogleLoginWrapper = styled(Flex)`
  width: 100%;
  margin-top: 4px;

  & > div {
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
  }
`;
